var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 2.99992V1.66659H5.66658V2.99992H8.33325ZM1.66659 4.99992V10.9999C1.66659 11.3666 1.96659 11.6666 2.33325 11.6666H11.6666C12.0333 11.6666 12.3333 11.3666 12.3333 10.9999V4.99992C12.3333 4.63325 12.0333 4.33325 11.6666 4.33325H2.33325C1.96659 4.33325 1.66659 4.63325 1.66659 4.99992ZM12.3333 2.99992C13.0733 2.99992 13.6666 3.59325 13.6666 4.33325V11.6666C13.6666 12.4066 13.0733 12.9999 12.3333 12.9999H1.66659C0.926585 12.9999 0.333252 12.4066 0.333252 11.6666L0.339919 4.33325C0.339919 3.59325 0.926585 2.99992 1.66659 2.99992H4.33325V1.66659C4.33325 0.926585 4.92659 0.333252 5.66658 0.333252H8.33325C9.07325 0.333252 9.66658 0.926585 9.66658 1.66659V2.99992H12.3333Z",
    fill: "#6E7705"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpIcon);
export default __webpack_public_path__ + "static/media/cpIcon.be07407842a9001bc1bd90b026b357ee.svg";
export { ForwardRef as ReactComponent };